import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
  <div class="modal-header colored-header colored-header-warning">
    <h4 class="m-0">${until(ctx.__('<tt-WYMrIOrz>', 'Warning'))}</h4>
    <button type="button" class="close" aria-label="Close" @click="${ctx.close}">
      <span class="ai ai-close-icon"></span>
    </button>
  </div>

  <div class="modal-body">
    <p tabindex="0" focusfirst>${until(ctx.__('<tt-xcV9DNGC>', 'By changing this email/phone, you are also changing this teacher\'s login email/phone. The teacher will be notified of this change, and passwords will remain unchanged. Proceed?'))}</p>

    <div class="row w-100 justify-content-center pt-5 mt-5">
      <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <button @click=${ctx.close} class="btn btn-block btn-outline-primary rounded-pill" type="submit">
          ${until(ctx.__('<tt-oMFm+vm8>', 'Cancel'))}
        </button>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <button @click=${ctx.saveChanges} class="btn btn-primary rounded-pill btn-block" type="submit">
          ${until(ctx.__('<tt-H0WTbeNn>', 'Save Changes'))}
        </button>
      </div>
    </div>
  </div>

  <div focuslast class="modal-footer justify-content-start">
    <p><strong>${until(ctx.__('<tt-OnGvdogJ>', 'Note:'))}</strong> ${until(ctx.__('<tt-T0Q43nBe>', 'It is recommended that teachers change their own emails and phone numbers, which they can do from their own profile pages.'))}</p>
  </div>
`;
